import React from 'react';
import { DropdownButton, MenuItem } from 'ui';
import ColorConstants from 'constants/ColorConstants';

const SORT_OPTIONS = [
  { value: 'newest_activity', label: 'Newest Activity' },
  { value: 'oldest_activity', label: 'Oldest Activity' },
  { value: 'transcript_order', label: 'Transcript Order' }
];

const SortDropdown = ({ value, onChange }) => {
  const currentOption = SORT_OPTIONS.find(opt => opt.value === value) || SORT_OPTIONS[0];

  const handleSelect = (eventKey) => {
    onChange(eventKey);
  };

  return (
    <DropdownButton
      id="sort-dropdown"
      variant="link"
      title={`Sort by: ${currentOption.label}`}
      onSelect={handleSelect}
      style={{
        padding: 0,
        textDecoration: 'none'
      }}
    >
      {SORT_OPTIONS.map(option => (
        <MenuItem
          key={option.value}
          eventKey={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </DropdownButton>
  );
};

export default SortDropdown;
